var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip__main--container",attrs:{"id":"custom-tooltip"}},[_c('div',{staticClass:"tooltip__info--main-container",style:(_vm.containerStyle)},[_c('div',{staticClass:"tooltip__arrow--box",class:_vm.arrowClass},[_vm._t("info")],2)]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }